module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/export-ddad8758d4ad5f4b78a27fe480402711.svg";